module.exports = __webpack_public_path__ + "img/wechart.53f4e59b.png";